import { useState, useEffect } from "react";
import emailjs from "@emailjs/browser";

export default function Contato() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [type, setType] = useState("");

  const colors = {
    black: "#000000",
    white: "#FFFFFF",
    purple3: "#873289",
  };

  // Inicializa o EmailJS
  useEffect(() => {
    emailjs.init("trQyCKqQXyF3MYwKT");
  }, []);

  const sendEmail = (e: any) => {
    e.preventDefault();

    if (name === "" || email === "" || message === "") {
      alert("Preencha todos os campos");
      return;
    }

    const templateParams = {
      to_name: "Laryssa Brilhante",
      from_name: name,
      message: message,
      email: email,
      type: type,
    };

    emailjs.send("service_7g2ba1c", "template_ver2p2c", templateParams).then(
      (response) => {
        console.log("Email enviado", response.status, response.text);
        alert("Mensagem enviada com sucesso!");
        setName("");
        setEmail("");
        setMessage("");
        setType("");
      },
      (err) => {
        console.log("Erro completo:", err);
        alert(
          `Erro ao enviar mensagem: ${
            err.text || err.message || "Tente novamente"
          }`
        );
      }
    );
  };

  return (
    <div className="container mx-auto px-4">
      <div className="max-w-2xl mx-auto">
        <div className="text-center mb-12">
          <h2
            className="text-3xl font-bold mb-4"
            style={{ color: colors.black }}
          >
            Entre em Contato
          </h2>
          <p className="text-gray-600">
            Preencha o formulário abaixo e entraremos em contato em até 24 horas
          </p>
        </div>
        <div className="bg-white rounded-lg shadow-xl p-8">
          <form className="space-y-6" onSubmit={sendEmail}>
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Nome
                </label>
                <input
                  type="text"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:border-transparent"
                  placeholder="Seu nome completo"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Email
                </label>
                <input
                  type="email"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:border-transparent"
                  placeholder="seu@email.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Estou interessado(a) em...
              </label>
              <select
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:border-transparent"
                value={type}
                onChange={(e) => setType(e.target.value)}
              >
                <option value="">Selecione uma opção</option>
                <option value="Desenvolvimento Web">Desenvolvimento Web</option>
                <option value="UX/UI Design">UX/UI Design</option>
                <option value="Gestão de Sites">Gestão de Sites</option>
                <option value="E-commerce">E-commerce</option>
                <option value="Outro">Outro</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Mensagem
              </label>
              <textarea
                rows={4}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:border-transparent"
                placeholder="Conte-nos sobre seu projeto..."
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                required
              ></textarea>
            </div>
            <button
              type="submit"
              className="w-full py-3 rounded hover:opacity-90 transition-opacity"
              style={{ backgroundColor: colors.purple3, color: colors.white }}
            >
              Enviar Mensagem
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
